import React from 'react';
import AuthService from './authService';
import serviceHelper from '../Helpers/serviceHelper';

class OpportunitySecurityChecklistService extends React.Component {
  static GetById(opportunityId) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/OpportunitySecurityChecklist/GetByIdAsync/${opportunityId}`
    );
  }

  static UpsertChecklist(item) {
    item = serviceHelper.ConvertAllPropertyToString(item);
    const JSONItem = JSON.stringify(item);

    if (item.OpportunitySecurityChecklistId == null || item.OpportunitySecurityChecklistId === '') {
      const url = '/api/OpportunitySecurityChecklist/CreateAsync';

      return AuthService.getInstance().CallBackendFunctionPost(url, JSONItem);
    }

    const url = '/api/OpportunitySecurityChecklist/UpdateAsync';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSONItem);
  }
}

export default OpportunitySecurityChecklistService;
